export enum ExportInsightsEvent {
  EXPORT_BUTTON_CLICK = 'Exportbutton klicken',
  START_EXPORT = 'Export nutzen',
}
